import React, { useEffect, useMemo, useState } from "react";
import "./styles.scss";
import logoIEEE from "../../../../../shared/resources/ieee mb tagline black.png";
import logoIN from "../../../../../shared/resources/in-logo-small.png";
import logoAllTeams from "../../../../../shared/resources/dashboard-icon-all-teams.png";
import logoAcceptedTeams from "../../../../../shared/resources/dashbord-icon-team-accepted.png";
import logoAllUsers from "../../../../../shared/resources/dashboard-icon-all-users.png";
import { ImDownload3 } from "react-icons/im";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useFirestore } from "reactfire";
import { CSVLink } from "react-csv";

interface FullReport {
  teamsApplied: number;
  teamsAccepted: number;
  totalUsers: number;
  industryData: YearsData<IndustryData>[];
  stageData: YearsData<StageData>[];
}

interface IndustryData {
  agriculture: number;
  eCommerce: number;
  edTech: number;
  education: number;
  finTech: number;
  health: number;
  logistics: number;
  media: number;
  retail: number;
  power: number;
  social: number;
  travelAndHospitality: number;
  robotics: number;
  informationSciences: number;
  others: number;
}

interface StageData {
  ideation: number;
  businessPlanFormulation: number;
  ideaValidatedAndMarketAnalyzed: number;
  mvpLaunched: number;
  earlyRevenue: number;
  growthAndExpansion: number;
}

interface IndustryChartData {
  name: string;
  value: number;
}

interface YearsData<T> {
  year: number;
  data: T;
}

const MainDashboard = () => {
  const [allData, setAllData] = useState<FullReport>();

  const store = useFirestore();

  // const createData = () => {
  //   const colRef = store.collection("dashboardData");
  //   colRef
  //     .doc("dashboardMetaDetails")
  //     .set({
  //       teamsAccepted: 0,
  //       teamsApplied: 0,
  //       totalUsers: 0,
  //       industryData: [],
  //       stageData: [],
  //     })
  //     .then(() => {
  //       console.log("data created");
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  useEffect(() => {
    const colRef = store.collection("dashboardData");
    colRef.doc("dashboardMetaDetails").onSnapshot((snap) => {
      setAllData(snap.data() as any);
    });
  }, [store]);

  const [activeIndustryYear, setActiveIndustryYear] = useState<number>(-1);
  const [activeStageYear, setActiveStageYear] = useState<number>(-1);

  const [industryCsvData, setIndustryCsvData] = useState<string[][]>([]);
  const [stageCsvData, setStageCsvData] = useState<string[][]>([]);

  useEffect(() => {}, [allData, activeIndustryYear]);

  const getIndustryValueString = (propertyValue: string) => {
    switch (propertyValue) {
      case "agriculture":
        return "Agriculture";
      case "eCommerce":
        return "ECommerce";
      case "edTech":
        return "EdTech";
      case "education":
        return "Education";
      case "finTech":
        return "FinTech";
      case "health":
        return "Health";
      case "logistics":
        return "Logistics";
      case "media":
        return "Media/Branding";
      case "retail":
        return "Retail";
      case "power":
        return "Power";
      case "social":
        return "Social";
      case "travelAndHospitality":
        return "Travel and Hospitality";
      case "robotics":
        return "Robotics";
      case "informationSciences":
        return "Information Sciences";
      default:
        return "Others";
    }
  };

  const getStageValueString = (propertyValue: string) => {
    switch (propertyValue) {
      case "ideation":
        return "Ideation";
      case "businessPlanFormulation":
        return "Business plan formulation";
      case "ideaValidatedAndMarketAnalyzed":
        return "Idea validated and market analyzed";
      case "mvpLaunched":
        return "MVP launched";
      case "earlyRevenue":
        return "Early revenue";
      case "growthAndExpansion":
        return "Growth and expansion";
      default:
        return "Others";
    }
  };

  const getSelectedIndustryData = useMemo<IndustryChartData[]>(() => {
    if (allData) {
      if (activeIndustryYear === -1) {
        const industryData: IndustryData = {
          agriculture: 0,
          eCommerce: 0,
          edTech: 0,
          education: 0,
          finTech: 0,
          health: 0,
          logistics: 0,
          media: 0,
          retail: 0,
          power: 0,
          social: 0,
          travelAndHospitality: 0,
          robotics: 0,
          informationSciences: 0,
          others: 0,
        };
        allData.industryData.forEach((ad) => {
          industryData.agriculture += ad.data.agriculture;
          industryData.eCommerce += ad.data.eCommerce;
          industryData.edTech += ad.data.edTech;
          industryData.finTech += ad.data.finTech;
          industryData.education += ad.data.education;
          industryData.health += ad.data.health;
          industryData.logistics += ad.data.logistics;
          industryData.media += ad.data.media;
          industryData.retail += ad.data.retail;
          industryData.power += ad.data.power;
          industryData.social += ad.data.social;
          industryData.travelAndHospitality += ad.data.travelAndHospitality;
          industryData.robotics += ad.data.robotics;
          industryData.informationSciences += ad.data.informationSciences;
          industryData.others += ad.data.others;
        });

        const data = Object.entries(industryData).map(([key, value]) => ({
          name: getIndustryValueString(key),
          value: value,
        }));
        let csvData = [
          ["Innovation Nation Sri Lanka", ""],
          [`Pre-Accelerator`, ""],
          [``, ""],
          [`Industry`, "total teams applied"],
        ];
        csvData = [...csvData, ...data.map((d) => [d.name, d.value])];
        setIndustryCsvData(csvData);
        return data;
      } else {
        const [yearData] = allData.industryData.filter(
          (d) => d.year === activeIndustryYear
        );
        if (yearData.data) {
          const data = Object.entries(yearData.data).map(([key, value]) => ({
            name: getIndustryValueString(key),
            value: value,
          }));
          let csvData = [
            ["Innovation Nation Sri Lanka", ""],
            [`Pre-Accelerator`, yearData.year.toString()],
            [``, ""],
            [`Industry`, "total teams applied"],
          ];
          csvData = [...csvData, ...data.map((d) => [d.name, d.value])];
          setIndustryCsvData(csvData);
          return data;
        }
      }
    }
    return [];
  }, [allData, activeIndustryYear]);

  const getSelectedStageData = useMemo<{
    total: number;
    data: StageData;
  } | null>(() => {
    if (allData) {
      if (activeStageYear === -1) {
        const stageData: StageData = {
          ideation: 0,
          businessPlanFormulation: 0,
          ideaValidatedAndMarketAnalyzed: 0,
          mvpLaunched: 0,
          earlyRevenue: 0,
          growthAndExpansion: 0,
        };

        allData.stageData.forEach((ad) => {
          stageData.ideation += ad.data.ideation;
          stageData.businessPlanFormulation += ad.data.businessPlanFormulation;
          stageData.ideaValidatedAndMarketAnalyzed +=
            ad.data.ideaValidatedAndMarketAnalyzed;
          stageData.mvpLaunched += ad.data.mvpLaunched;
          stageData.earlyRevenue += ad.data.earlyRevenue;
          stageData.growthAndExpansion += ad.data.growthAndExpansion;
        });

        const total = Object.entries(stageData)
          .map(([key, value]) => value)
          .reduce((a, b) => a + b, 0);

        let csvData = [
          ["Innovation Nation Sri Lanka", ""],
          [`Pre-Accelerator`, ""],
          [``, ""],
          [`Stage`, "total teams applied"],
        ];
        csvData = [
          ...csvData,
          ...Object.entries(stageData).map(([key, value]) => [
            getStageValueString(key.toString()),
            value.toString(),
          ]),
        ];
        setStageCsvData(csvData);

        return { data: stageData, total: total };
      } else {
        const [yearData] = allData?.stageData?.filter(
          (d) => d.year === activeStageYear
        );
        const total = Object.entries(yearData.data)
          .map(([key, value]) => value)
          .reduce((a, b) => a + b, 0);
        if (yearData.data) {
          const data = yearData.data;
          let csvData = [
            ["Innovation Nation Sri Lanka", ""],
            [`Pre-Accelerator`, yearData.year.toString()],
            [``, ""],
            [`Stage`, "total teams applied"],
          ];
          csvData = [
            ...csvData,
            ...Object.entries(data).map(([key, value]) => [
              getStageValueString(key.toString()),
              value.toString(),
            ]),
          ];
          setStageCsvData(csvData);
          return { data, total: total };
        }
      }
    }
    return null;
  }, [allData, activeStageYear]);

  // const Label = (props: any) => {
  //   const { x, y, name } = props;
  //   console.log(props);

  //   return (
  //     <text
  //       x={x}
  //       y={y}
  //       dx={"2%"}
  //       dy={"10%"}
  //       fontSize="10"
  //       fontWeight="bold"
  //       fill={"#181818"}
  //       textAnchor="centor"
  //       transform="rotate(90deg)"
  //     >
  //       {name}
  //     </text>
  //   );
  // };

  return (
    <div className="main-dashboard-container">
      {/* <button
        className="app-button"
        onClick={() => {
          createData();
        }}
      >
        Create Doc
      </button> */}
      <div className="d-header-wrapper">
        <div className="header-text">
          <h2 className="main-text">Innovation Nation</h2>
          <h3 className="secondry-text">
            Pre-Accelerator {new Date().getFullYear()}
          </h3>
        </div>
        <div className="header-logos">
          <img src={logoIN} alt="" />
          <img src={logoIEEE} alt="" />
        </div>
      </div>
      <div className="d-cards">
        <SimpleReportCard
          logo={logoAllTeams}
          title="Teams Applied"
          value={allData?.teamsApplied || 0}
        />
        <SimpleReportCard
          logo={logoAcceptedTeams}
          title="Teams Accepted"
          value={allData?.teamsAccepted || 0}
        />
        <SimpleReportCard
          logo={logoAllUsers}
          title="Total Users"
          value={allData?.totalUsers || 0}
        />
      </div>
      <div className="data-cards">
        <div className="industry-card">
          <div className="ctitle-wrapper">
            <div>
              <label>Breakdown of History</label>
            </div>
            <div>
              <CSVLink data={industryCsvData} filename="Breakdown of History">
                <ImDownload3 />
              </CSVLink>
            </div>
          </div>
          <div className="filters-year">
            <FilterLabel
              active={activeIndustryYear === -1}
              onClick={() => {
                setActiveIndustryYear(-1);
              }}
              text="All times"
            />
            {allData?.industryData
              .map((id) => id.year)
              .map((year, index) => (
                <FilterLabel
                  key={index}
                  active={activeIndustryYear === year}
                  onClick={(value) => {
                    setActiveIndustryYear(value);
                  }}
                  text={year.toString()}
                />
              ))}
          </div>
          <div className="industry-chart">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={getSelectedIndustryData.sort((a, b) =>
                  a.name.localeCompare(b.name)
                )}
                margin={{
                  top: 20,
                  right: 0,
                  left: 0,
                  bottom: 0,
                }}
              >
                <CartesianGrid strokeDasharray="0" vertical={false} />
                <XAxis
                  dataKey="name"
                  axisLine={false}
                  tick={{ fontSize: "10px", fontWeight: "bold" }}
                />
                <YAxis
                  axisLine={false}
                  tick={{ fontSize: "10px", fontWeight: "bold" }}
                />
                <Tooltip cursor={{ fill: "#fAfAfA" }} />
                <Bar
                  dataKey="value"
                  fill="#09a9f3"
                  radius={[10, 10, 0, 0]}
                  barSize={8}
                />
                {/* <Bar dataKey="uv" fill="#82ca9d" /> */}
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="stage-card">
          <div className="ctitle-wrapper">
            <div>
              <label>Breakdown of Business Stage</label>
            </div>
            <div>
              <CSVLink
                data={stageCsvData}
                filename="Breakdown of Business Stage"
              >
                <ImDownload3 />
              </CSVLink>
            </div>
          </div>
          <div className="filters-year">
            <FilterLabel
              active={activeStageYear === -1}
              onClick={() => {
                setActiveStageYear(-1);
              }}
              text="All times"
            />
            {allData?.stageData
              .map((id) => id.year)
              .map((year, index) => (
                <FilterLabel
                  key={index}
                  active={activeStageYear === year}
                  onClick={(value) => {
                    setActiveStageYear(value);
                  }}
                  text={year.toString()}
                />
              ))}
          </div>
          <div className="stage-data">
            <OneStage
              color="#5289c9"
              name="Ideation"
              value={getSelectedStageData?.data.ideation || 0}
              totalValue={getSelectedStageData?.total || 0}
            />
            <OneStage
              color="#2862ff"
              name="Business plan formulation"
              value={getSelectedStageData?.data.businessPlanFormulation || 0}
              totalValue={getSelectedStageData?.total || 0}
            />
            <OneStage
              color="#ff6a81"
              name="Idea validated and market analyzed"
              value={
                getSelectedStageData?.data.ideaValidatedAndMarketAnalyzed || 0
              }
              totalValue={getSelectedStageData?.total || 0}
            />
            <OneStage
              color="#eb4a8a"
              name="MVP launched"
              value={getSelectedStageData?.data.mvpLaunched || 0}
              totalValue={getSelectedStageData?.total || 0}
            />
            <OneStage
              color="#54c46d"
              name="Early revenue"
              value={getSelectedStageData?.data.earlyRevenue || 0}
              totalValue={getSelectedStageData?.total || 0}
            />
            <OneStage
              color="#d063f7"
              name="Growth and expansion"
              value={getSelectedStageData?.data.growthAndExpansion || 0}
              totalValue={getSelectedStageData?.total || 0}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainDashboard;

interface IReportCardProps {
  logo: any;
  title: string;
  value: number;
}

const SimpleReportCard = (props: IReportCardProps) => {
  return (
    <div className="simple-report-card-wrapper">
      <div className="dimage">
        <img src={props.logo} alt="" />
      </div>
      <div className="ddetails">
        <div>
          <h1>{props.value}</h1>
          <label>{props.title}</label>
        </div>
      </div>
    </div>
  );
};

interface IFilterLabelProps {
  text: string;
  active?: boolean;
  onClick: (value: number) => void;
}

const FilterLabel = (props: IFilterLabelProps) => {
  return (
    <div
      className={props.active ? "filter-label fl-active" : "filter-label"}
      onClick={() => props.onClick(+props.text)}
    >
      {props.text}
    </div>
  );
};

interface IOneStageProps {
  name: string;
  value: number;
  totalValue: number;
  color: string;
}

const OneStage = (props: IOneStageProps) => {
  return (
    <div className="one-stage-wrapper">
      <div className="stage-title">
        <div className="stage-name">
          <label>{props.value}</label> <span>{props.name}</span>
        </div>
        <div className="statge-per">
          {Math.round((props.value / props.totalValue) * 100) || 0}%
        </div>
      </div>
      <div className="stage-bar">
        <div className="bar-wraber">
          <div
            className="bar"
            style={{
              backgroundColor: props.color,
              width:
                Math.round((props.value / props.totalValue) * 100 || 0) + "%",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

// const sampleData: FullReport = {
//   teamsAccepted: 100,
//   teamsApplied: 200,
//   totalUsers: 500,
//   industryData: [
//     {
//       year: 2019,
//       data: {
//         agriculture: 100,
//         eCommerce: 350,
//         edTech: 75,
//         finTech: 100,
//         health: 50,
//         logistics: 200,
//         media: 60,
//         retail: 60,
//         power: 80,
//         social: 22,
//         travelAndHospitality: 50,
//         robotics: 50,
//         informationSciences: 200,
//         others: 10,
//       },
//     },
//     {
//       year: 2020,
//       data: {
//         agriculture: 100,
//         eCommerce: 150,
//         edTech: 250,
//         finTech: 50,
//         health: 70,
//         logistics: 120,
//         media: 78,
//         retail: 28,
//         power: 10,
//         social: 200,
//         travelAndHospitality: 355,
//         robotics: 50,
//         informationSciences: 452,
//         others: 15,
//       },
//     },
//   ],
//   stageData: [
//     {
//       year: 2019,
//       data: {
//         ideation: 100,
//         businessPlanFormulation: 60,
//         ideaValidatedAndMarketAnalyzed: 80,
//         mvpLaunched: 20,
//         earlyRevenue: 200,
//         growthAndExpansion: 130,
//       },
//     },
//     {
//       year: 2020,
//       data: {
//         ideation: 50,
//         businessPlanFormulation: 200,
//         ideaValidatedAndMarketAnalyzed: 120,
//         mvpLaunched: 150,
//         earlyRevenue: 75,
//         growthAndExpansion: 180,
//       },
//     },
//   ],
// };
